var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBrokenImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.44,
    height: 79.44,
    viewBox: "0 0 79.44 79.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-broken-image",
    transform: "translate(-9.784 -9.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M82.44,11.827V40.911L69.2,27.626l-17.653,17.7L33.893,27.671,16.24,45.324,3,32.04V11.827A8.853,8.853,0,0,1,11.827,3H73.613A8.853,8.853,0,0,1,82.44,11.827ZM69.2,40.16,82.44,53.444V73.613a8.853,8.853,0,0,1-8.827,8.827H11.827A8.853,8.853,0,0,1,3,73.613V44.574l13.24,13.2L33.893,40.116,51.547,57.769Z",
    transform: "translate(6.784 6.784)",
    fill: "#8b9095"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBrokenImage);
export default __webpack_public_path__ + "static/media/ic-broken-image.3cb82486.svg";
export { ForwardRef as ReactComponent };